import React, { useCallback, useMemo } from 'react'
import { PaymentFormattedLI, PaymentTypesType } from '@bcraft-frontend-lib/payments'
import block from 'bem-cn'

import { ReactComponent as ArrowSvg } from 'shared/img/payment/arrow.svg'

import { LocalePaymentType } from 'shared/locale/en-US'

import { DescriptionBlock } from '../DescriptionBlock/DescriptionBlock'

import './AdditionalPayment.scss'

type IAdditionalPayment = {
  paymentType: PaymentTypesType
  systemItem: PaymentFormattedLI
  locale: LocalePaymentType
  changeSystem: (system: string) => void
}

const b = block('additional-payment')

export const AdditionalPayment: React.FC<IAdditionalPayment> = ({ systemItem, paymentType, locale, changeSystem }) => {
  const paymentKey = useMemo(() => `${paymentType}_${systemItem?.slug}`, [paymentType, systemItem?.slug])

  const renderComponent = useMemo(() => {
    switch (paymentKey) {
      default:
        return (
          <div className={b('content')}>
            <DescriptionBlock paymentKey={`${paymentType}_${systemItem?.slug}`} />
          </div>
        )
    }
  }, [paymentKey, paymentType, systemItem?.slug])

  const onCloseCurrentPayment = useCallback(() => {
    changeSystem('')
  }, [changeSystem])

  return (
    <div className={b()}>
      <div className={b('header')}>
        <span className={b('header-arrow')} onClick={onCloseCurrentPayment}>
          <ArrowSvg className={b('header-arrow-icon')} />
        </span>
        <span className={b('header-title')}>{locale[paymentType]}</span>
      </div>
      {renderComponent}
    </div>
  )
}
